/* eslint-disable react/no-danger */
import {
  allLanguageSelectOptions,
  breederRegionOptions,
  countrySelectOptions,
  useRouter,
} from '@application/utils';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { BREEDER_LANGUAGE_CODES } from '@application/constants';
import { InputField, InputLabel, InputSelectField } from '@presentation/components';
import { useFormikContext } from 'formik';
import type { MtBreederOnboardingFormValues } from '../types';
import * as Styled from '../styled';

export const Step1: FC = () => {
  const { translate } = useTranslation();
  const { language, countryCode } = useRouter();
  const { values } = useFormikContext<MtBreederOnboardingFormValues>();

  const currentCountryCode = values?.country ?? countryCode;

  const regionOptions = breederRegionOptions(translate, currentCountryCode);
  const countryOptions = countrySelectOptions(translate);

  return (
    <>
      <Styled.OnboardingInputWrapper>
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.spokenLanguages.label')}
        </InputLabel>
        <InputSelectField
          name="spokenLanguages"
          multiple
          dismissOnClick={false}
          options={allLanguageSelectOptions(language, BREEDER_LANGUAGE_CODES)}
          hasDropdownIcon
          variant="new"
        />
      </Styled.OnboardingInputWrapper>

      <Styled.OnboardingInputWrapper split>
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.city.label')}
        </InputLabel>
        <InputField name="city" />
      </Styled.OnboardingInputWrapper>

      <Styled.OnboardingInputWrapper split last>
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.zipcode.label')}
        </InputLabel>
        <InputField name="zip" />
      </Styled.OnboardingInputWrapper>

      <Styled.OnboardingInputWrapper split>
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.region.label')}
        </InputLabel>
        <InputSelectField name="region" options={regionOptions} hasDropdownIcon variant="new" />
      </Styled.OnboardingInputWrapper>

      <Styled.OnboardingInputWrapper split last>
        <InputLabel requiredColor="red" required>
          {translate('common.inputs.country.label')}
        </InputLabel>
        <InputSelectField
          disabled
          name="country"
          options={countryOptions}
          hasDropdownIcon
          variant="new"
        />
      </Styled.OnboardingInputWrapper>
    </>
  );
};
